import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  InputTextWrapper,
  InputNumberWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {EnterpriseModel, LocationModel} from '../../../../model'
import {getCountry, getEnterpriseById} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {TITLE_FORM_ENTERPRISE} from '../../../../util/Constants'
import {fetchData} from '../../../../util/functions'
import {mapDataSelect} from '../../../../../../util/functions'
import useDepartmentList from '../../../../hooks/useDepartment'
import {useProvince, useDistrict} from '../../../../hooks'
import {initValues} from '../../../../util/values/enterprise'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {valueIdCountry} from '../../../../../../util/Constants'
const Enterprise: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {mappedSelectDepartmentList} = useDepartmentList()
  const {
    province,
    province2,
    getProvince1,
    getProvince2,
    handleClearProvince,
    handleClearProvince2,
  } = useProvince()
  const {
    district,
    district2,
    getDistrict1,
    getDistrict2,
    handleClearDistrict,
    handleClearDistrict2,
  } = useDistrict()
  const [country, setCountry] = useState<LocationModel[] | any>([])

  const getCountryList = async () => {
    const countryData = (await fetchData({fetchFunction: getCountry})) || []
    const mappedData = mapDataSelect(countryData)
    setCountry(mappedData)
  }

  const getEnterpriseByIdValues = async () => {
    const response = await getEnterpriseById(currentTabItem.idToEdit)
    const data = response.data.data
    type EnterpriseModelKeys = keyof EnterpriseModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as EnterpriseModelKeys]) {
            if (fieldName === 'departamentoId1') {
              let valueDep = data[fieldName as EnterpriseModelKeys]
              if (typeof valueDep === 'string') {
                setValue(fieldName, valueDep)
                getProvince1(valueDep)
              }
            }
            if (fieldName === 'provinciaId1') {
              let valueProv = data[fieldName as EnterpriseModelKeys]
              if (typeof valueProv === 'string') {
                setValue(fieldName, valueProv)
                getDistrict1(valueProv)
              }
            }
            if (fieldName === 'departamentoId2') {
              let valueDep = data[fieldName as EnterpriseModelKeys]
              if (typeof valueDep === 'string') {
                setValue(fieldName, valueDep)
                getProvince2(valueDep)
              }
            }
            if (fieldName === 'provinciaId2') {
              let valueProv = data[fieldName as EnterpriseModelKeys]
              if (typeof valueProv === 'string') {
                setValue(fieldName, valueProv)
                getDistrict2(valueProv)
              }
            }
            if (fieldName === 'paisId') {
              setValue(fieldName, valueIdCountry)
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as EnterpriseModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as EnterpriseModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as EnterpriseModelKeys] ?? '')
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    setValue('paisId', valueIdCountry)
    getCountryList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEnterpriseByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleDepartmentChange1 = (val: any) => {
    let value = val ? val.value : ''
    handleClearProvince()
    handleClearDistrict()
    getProvince1(value)
  }
  const handleProvinceChange1 = (val: any) => {
    let value = val ? val.value : ''
    getDistrict1(value)
    handleClearProvince2()
  }
  const handleDepartmentChange2 = (val: any) => {
    let value = val ? val.value : ''
    handleClearProvince2()
    handleClearDistrict2()
    getProvince2(value)
  }

  const handleProvinceChange2 = (val: any) => {
    let value = val ? val.value : ''
    handleClearDistrict2()
    getDistrict2(value)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_ENTERPRISE}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Nro de documento'
            name='ruc'
            textPlaceholder='Escribe el nro de documento'
            maxLength={21}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Razón social'
            name='nombre'
            textPlaceholder='Escribe el nombre'
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='País' name='paisId' data={country} disabled={true} required />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Teléfono 1'
            name='telefono1'
            textPlaceholder='Escribe el teléfono'
            type={'telephone'}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Teléfono 2'
            name='telefono2'
            textPlaceholder='Escribe el teléfono'
            type={'telephone'}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Dirección 1'
            name='direccion1'
            textPlaceholder='Escribe la dirección'
            type='address'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Departamento 1'
            disabled={mappedSelectDepartmentList.length === 0}
            name='departamentoId1'
            data={mappedSelectDepartmentList}
            onChangeValue={handleDepartmentChange1}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Provincia 1'
            disabled={province.length === 0}
            name='provinciaId1'
            data={province}
            onChangeValue={handleProvinceChange1}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Distrito 1'
            disabled={district.length === 0}
            name='ubigeo1'
            data={district}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Referencia 1'
            name='referencia1'
            textPlaceholder='Escribe la referencia'
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Dirección 2'
            name='direccion2'
            textPlaceholder='Escribe la dirección'
            type='address'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Departamento 2'
            disabled={mappedSelectDepartmentList.length === 0}
            name='departamentoId2'
            data={mappedSelectDepartmentList}
            onChangeValue={handleDepartmentChange2}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Provincia 2'
            disabled={province2.length === 0}
            name='provinciaId2'
            data={province2}
            onChangeValue={handleProvinceChange2}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Distrito 2'
            disabled={district2.length === 0}
            name='ubigeo2'
            data={district2}
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Referencia 2'
            name='referencia2'
            textPlaceholder='Escribe la referencia'
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Enterprise
